// extracted by mini-css-extract-plugin
export default {"page":"vO","freeShippingContainer":"wO","customizeContainer":"xO","customizeHeader":"yO","fadein":"zO","customizeText":"AO","hidden":"BO","productcard":"CO","accordeonscontainer":"EO","freeShipping":"FO","mainpart":"GO"};
    if(module.hot) {
      // 1711717534209
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  